module.exports = __webpack_public_path__ + "static/media/clue-5.d8ae46da.svg";